/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useClipboard = require("./useClipboard");
var clipboard = {
  name: 'clipboard',
  hook: _useClipboard.useClipboard,
  defaultProps: function defaultProps() {
    return {};
  }
};
var _default = clipboard;
exports.default = _default;